import React from 'react';
import { MaterialDataCard } from '../../../../../../components/UI-Elements/Grids/MaterialDataGrid';
import { ToggleNumberInput } from '../../../../../../components/UI-Elements/ToogleNumber/ToggleNumberInput';
import { Material } from '../../../../../../sp-types';
import { IFutureOrder } from '../../../../../../sp-types/FutureOrderType';
import { formatToPriceInDollars, formatToShortString } from '../../../../../../utils/FormatValue';
import { updateSupplierExposureByLeadTime } from '../../../AddNewFutureOrderUtils';
import { getUnitObj } from '../../../../../../utils/MassUnits/massUnitsUtils';
import { useCurrencyRates } from '@hooks/useCurrencyRates';

interface BackToBackMaterialCardsProps {
  currentFutureOrder: IFutureOrder;
  setCurrentFutureOrder: (_value: IFutureOrder) => void;
  materialsMap: Record<string, Material>;
  colorDict: Record<string, string>;
}
export const BackToBackMaterialCards: React.FC<BackToBackMaterialCardsProps> = ({
  currentFutureOrder,
  setCurrentFutureOrder,
  colorDict,
  materialsMap,
}) => {
  const { supplierExposure, orderDetails } = currentFutureOrder;
  const { quantity, productDeliveryCalendar } = orderDetails;
  const { pricesMap } = useCurrencyRates();

  return (
    <MaterialDataCard
      materialsData={supplierExposure.map((item, index) => ({
        materialNameSize: 100,
        materialId: item.materialId,
        data: [
          {
            title: 'Quantity',
            valueAsString: `${formatToShortString(item.weightInProduct * quantity, 0)} ${
              getUnitObj(materialsMap[item.materialId].unit).shortForm
            }`,
          },
          {
            title: 'Material Price',
            valueAsString: formatToPriceInDollars(pricesMap[item.materialId], 1),
          },
          {
            title: 'Total expected price',
            valueAsString: formatToPriceInDollars(item.weightInProduct * quantity * pricesMap[item.materialId]),
          },
          <div key={index} className="w-[11rem]  space-y-1 ">
            <p className="text-sm text-secondary_text">Supply lead time</p>
            <ToggleNumberInput
              downLimit={0}
              upperLimit={36}
              setValueState={(value: number) => {
                productDeliveryCalendar &&
                  setCurrentFutureOrder({
                    ...currentFutureOrder,
                    supplierExposure: updateSupplierExposureByLeadTime(
                      supplierExposure,
                      item.materialId,
                      value,
                      productDeliveryCalendar,
                    ),
                  });
              }}
              valueState={item.supplyLeadTime}
              suffix="m"
            />
          </div>,
        ],
      }))}
      title="Materials"
      materialsMap={materialsMap}
      materialColorDictionary={colorDict}
    />
  );
};
